import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  imports: [AsyncPipe],
})
export class TabsComponent {
  @Input() public tabs: ITab[] = [];
  @Input() public selected$!: BehaviorSubject<string | null>;

  public onSelect(option: string): void {
    if (this.selected$.value === option) return;
    this.selected$.next(option);
  }
}

export interface ITab {
  name: string;
  icon?: string;
}
